module.exports = __webpack_public_path__ + "catalog/items/livingroom/Curvychair/Curvychair.svg";